import React, { useState } from 'react';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { useTranslation } from '../hooks/useTranslation';
import { Link as ScrollLink } from 'react-scroll';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collaborator, Language, Translation } from '../mlva-types';
import { isUserAgentMobile } from '../hooks/useIsDesktop';

export const Collaborators = ({
  collaborators,
  language,
}: {
  collaborators: Collaborator[];
  language: Language;
}) => {
  const COLLABORATORS_HEADER = useTranslation(
    'Collaborators',
    'Colaboradores',
    language
  );

  const [collaboratorOnSpotlight, setCollaboratorOnSpotlight] =
    useState<Collaborator | null>(null);

  const isTouch = isUserAgentMobile();

  const handleSpotlightChange = (collaborator: Collaborator) => {
    if (collaboratorOnSpotlight == collaborator) {
      setCollaboratorOnSpotlight(null);
    } else {
      setCollaboratorOnSpotlight(collaborator);
    }
  };

  return (
    <div className="columns is-mobile is-multiline">
      <div className="column is-2-desktop is-2-tablet is-5-mobile pb-0">
        <div>{COLLABORATORS_HEADER}</div>
      </div>
      {collaborators?.map((collaborator: Collaborator, index: number) => {
        return (
          <React.Fragment key={index}>
            {index > 0 && (
              <div className="column is-2-desktop is-2-tablet is-5-mobile pb-0" />
            )}
            <div className={`column ${index === 0 ? 'pb-0 pt-3' : 'py-0'}`}>
              <ScrollLink
                to="collaborator-spotlight"
                spy={true}
                smooth={true}
                offset={isTouch ? -200 : -366}
                delay={200}
                duration={500}
                onClick={() => handleSpotlightChange(collaborator)}
              >
                <div className="columns is-mobile my-0">
                  <div
                    className={`column py-0 pr-0 is-2-desktop is-4-tablet is-10-mobile${
                      collaboratorOnSpotlight == collaborator
                        ? ' has-text-weight-medium'
                        : ''
                    }`}
                  >
                    {collaborator.name}
                  </div>
                  <div
                    className={`column py-0 is-1 has-text-centered is-unselectable${
                      collaboratorOnSpotlight == collaborator
                        ? ' icon-weight-stronger'
                        : ''
                    }`}
                  >
                    {collaboratorOnSpotlight == collaborator ? (
                      <FontAwesomeIcon icon={faMinus} size="2xs" />
                    ) : (
                      <FontAwesomeIcon icon={faPlus} size="2xs" />
                    )}
                  </div>
                </div>
              </ScrollLink>
            </div>
            <section
              className={`column is-12 slide-down py-0 ${
                collaboratorOnSpotlight == collaborator ? 'active' : ''
              }`}
              id="collaborator-spotlight"
            >
              <div className="columns py-4">
                <div
                  className={`column is-4${
                    index < collaborators.length - 1 ? ' pb-5' : ''
                  }`}
                >
                  {collaborator.description?.map(
                    (paragraph: Translation, index: number) => {
                      return (
                        <div key={index} className="block has-text-justified">
                          {useTranslation(paragraph.en, paragraph.pt, language)}
                        </div>
                      );
                    }
                  )}
                  {collaborator?.photo && (
                    <GatsbyImage
                      image={getImage(collaborator?.photo) as IGatsbyImageData}
                      alt={collaborator.name}
                      className="collaborator-photo-container"
                    />
                  )}
                </div>
              </div>
            </section>
          </React.Fragment>
        );
      })}
    </div>
  );
};
